<template>
  <Container>
    <v-flex>
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title
            >Slide Puzzle Manager {{ announcement }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn icon color="green" @click="createSlidePuzzleGroup">
            <v-icon>add</v-icon>
          </v-btn>
          <v-text-field
            solo
            placeholder="Search"
            append-icon="search"
            hide-details
          ></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-list>
            <v-list-tile
              v-for="slidePuzzle in gameListStore"
              :key="slidePuzzle._id"
              @click="onClickSelect(slidePuzzle)"
            >
              <v-list-tile-avatar>
                <v-icon>import_contacts</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title
                  >{{ slidePuzzle.category }} ({{
                    slidePuzzle.number_of_game
                  }})</v-list-tile-title
                >
                <v-list-tile-sub-title
                  >Updated at
                  {{ slidePuzzle.updated_at }}</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>
    <Modal
      v-if="isCreate"
      :isOpen="isCreate"
      :save="onSaveCreate"
      :close="closeModalCreate"
      :isLastStep="valid"
      title="Create Game"
    >
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-container>
            <v-layout grid-list-xs column text-xs-center>
              <v-flex>
                <v-autocomplete
                  chips
                  required
                  label="Select Category"
                  :items="categoryListStore"
                  item-text="category"
                  item-value="_id"
                  hide-details
                  hide-no-data
                  hide-selected
                  :rules="requiredRule"
                  v-model="slide_puzzle.category_id"
                ></v-autocomplete>
                <v-text-field
                  label="Title"
                  v-model="slide_puzzle.title"
                ></v-text-field>
                <v-autocomplete
                  chips
                  required
                  label="Select Slide Puzzle Size"
                  :items="constant.SLIDE_PUZZLE_SIZE"
                  item-text="text"
                  item-value="value"
                  hide-details
                  hide-no-data
                  hide-selected
                  v-model.number="slide_puzzle.size"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-form>
    </Modal>
    <Modal
      v-if="isOpenModalSubBackground"
      :isOpen="isOpenModalSubBackground"
      :save="onSaveSubBackground"
      :close="closeModalSubBackground"
      :isLastStep="true"
      title="Sub Background"
    >
      <v-flex xs12 sm12 md12>
        <v-btn color="success" small fab @click="increaseStep('')"
          ><v-icon>add</v-icon>
        </v-btn>
        <v-stepper v-model="element.sub_background">
          <v-stepper-header>
            <template v-for="n in step.sub_background">
              <v-stepper-step
                :key="`${n}-step`"
                :complete="element.sub_background > n"
                :step="n"
                editable
              >
                Sub Background {{ n }}
              </v-stepper-step>

              <v-divider v-if="n !== step.sub_background" :key="n"></v-divider>
            </template>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content
              v-for="step in step.sub_background"
              :key="`${step}-content`"
              :step="step"
            >
              <v-flex>
                <v-btn
                  color="error"
                  small
                  absolute
                  fab
                  right
                  @click="reduceStep(step)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <img
                  v-if="
                    slide_puzzle.sub_background_list[step - 1]
                      .sub_background_uri
                  "
                  :src="
                    slide_puzzle.sub_background_list[step - 1]
                      .sub_background_uri
                  "
                  class="content_img"
                />
                <v-text-field
                  label="Sub Background URI (URL or Select file)"
                  v-model="
                    slide_puzzle.sub_background_list[step - 1]
                      .sub_background_uri
                  "
                ></v-text-field>
                <v-btn
                  dark
                  @click="
                    isSelectSubBackground = true;
                    isSelectImage = true;
                  "
                >
                  <v-icon>image</v-icon>Select Sub Background
                </v-btn>
                <v-text-field
                  label="Sub Background Speed"
                  type="number"
                  v-model="
                    slide_puzzle.sub_background_list[step - 1]
                      .sub_background_speed
                  "
                ></v-text-field>
              </v-flex>
              <v-btn color="primary" @click="nextStep(step)"> Next </v-btn>
              <v-btn flat @click="backStep(step)"> Back </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </Modal>
    <ResourceSelect
      v-if="isSelectImage"
      resourceType="image"
      :isShow="isSelectImage"
      :close="closeSelectImage"
      :save="saveSelectImage"
      :value="selectImageUri"
      :onSelect="onSelectImage"
    />
    <ResourceSelect
      v-if="isSelectSound"
      resourceType="sound"
      :isShow="isSelectSound"
      :close="closeSelectSound"
      :save="saveSelectSound"
      :value="selectSoundUri"
      :onSelect="onSelectSound"
    />
  </Container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Container from '../../components/Container';
import Modal from '../../components/Modal';
import ResourceSelect from '../../components/ResourceSelect';
import constant from './constant';
export default {
  name: 'SlidePuzzle',
  components: { Container, Modal, ResourceSelect },
  data() {
    return {
      announcement: '(Available on v3.4)',
      constant,
      element: {
        sub_background: 1,
      },
      step: {
        sub_background: 1,
      },
      isSelectSubBackground: false,
      isOpenModalSubBackground: false,
      isSelectSound: false,
      selectSoundUri: '',
      isSelectParticleUri: false,
      isSelectImage: false,
      selectImageUri: '',
      slide_puzzle: {
        category_id: '',
        title: '',
        size: 2,
        is_auto_generate: true,
        card: {},
      },
      requiredRule: [v => !!v || 'This field is required'],
      isCreate: false,
      valid: false,
    };
  },
  computed: {
    ...mapState({
      categoryListStore: state => state.category.category,
      slidePuzzleStore: state => state.slide_puzzle,
      gameListStore: state => state.slide_puzzle.GAME_LIST,
      createState: state => state.slide_puzzle.CREATE,
    }),
  },
  methods: {
    ...mapActions('category', ['fetchCategory']),
    ...mapActions('slide_puzzle', [
      'resetCreateState',
      'createGameData',
      'getGameList',
      'getGameData',
      'setSelectedGameListState',
    ]),
    onClickSelect(data) {
      const id = data._id;
      this.getGameData(id);
      this.setSelectedGameListState(data);
      this.$router.push({
        path: '/slide_puzzle/detail',
        query: {
          id,
        },
      });
    },
    async createSlidePuzzleGroup() {
      // this.reset();
      await this.fetchCategory({
        page: 1,
        limit: 0,
      });
      this.isCreate = true;
    },
    openModalSubBackground() {
      this.isOpenModalSubBackground = true;
    },
    addDefaultObjectSubBackground() {
      const formatObject = {
        sub_background_uri: '',
      };
      this.slide_puzzle.sub_background_list.push(formatObject);
    },
    increaseStep() {
      const max = 3;
      if (this.step.sub_background < max) {
        this.step.sub_background += 1;
        this.addDefaultObjectSubBackground();
      }
    },
    reduceStep(step) {
      let index = step - 1;
      if (this.step.sub_background > 1) {
        this.step.sub_background -= 1;
        this.slide_puzzle.sub_background_list.splice(index, 1);
      }
    },
    nextStep(currentStep) {
      if (currentStep === this.step.sub_background) {
        this.element.sub_background = 1;
      } else {
        this.element.sub_background = currentStep + 1;
      }
    },
    backStep(currentStep) {
      if (currentStep > 1) {
        this.element.sub_background -= 1;
      }
    },
    onSaveSubBackground() {
      this.isOpenModalSubBackground = false;
    },
    closeModalSubBackground() {
      this.isOpenModalSubBackground = false;
    },
    closeSelectSound() {
      this.selectSoundUri = '';
      this.isSelectSound = !this.isSelectSound;
    },
    saveSelectSound() {
      const uri = this.selectSoundUri;
      this.slide_puzzle.sound_uri = uri;
      this.selectSoundUri = '';
      this.isSelectSound = !this.isSelectSound;
    },
    closeSelectImage() {
      this.selectImageUri = '';
      this.isSelectImage = !this.isSelectImage;
    },
    saveSelectImage() {
      const uri = this.selectImageUri;
      if (this.isSelectSubBackground) {
        this.slide_puzzle.sub_background_list[
          this.element.sub_background - 1
        ].sub_background_uri = uri;
      } else if (this.isSelectParticleUri) {
        this.slide_puzzle.player_data.particle_uri = uri;
      } else {
        this.slide_puzzle.background_uri = uri;
      }
      this.selectImageUri = '';
      this.isSelectSubBackground = false;
      this.isSelectImage = false;
      this.isSelectParticleUri = false;
    },
    onSelectImage(uri) {
      this.selectImageUri = uri;
    },
    onSelectSound(uri) {
      this.selectSoundUri = uri;
    },
    reset() {
      this.$refs.form.reset();
      this.resetStep();
      this.resetValidation();
    },
    resetStep() {
      this.step.sub_background = 1;
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    closeModalCreate() {
      this.isCreate = false;
    },
    onSaveCreate() {
      this.isCreate = false;
      const gameObject = {
        ...this.slide_puzzle,
      };
      this.createGameData(gameObject);
    },
  },
  mounted() {
    this.getGameList();
  },
};
</script>

<style scoped>
.content_img {
  height: 150px;
  width: 150px;
  border-radius: 5px;
}
</style>
